module.exports = __webpack_public_path__ + "hipchat-logo.png";